var Handlebars = require('/src/melia-widget/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\""
    + alias4(((helper = (helper = helpers.identifier || (depth0 != null ? depth0.identifier : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"identifier","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + " lmm-message-control\">\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./lmm-widget/src/components/messageControl/messageControl.hbs
// module id = 138
// module chunks = 1